import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
    Investor,
    InvestorAddress,
    InvestorBankData,
    InvestorContact,
    InvestorFile,
    InvestorFiscalData,
    Unit,
    Income,
    Expense,
    Property,
    Category,
    Contract,
    Insurance,
    UnitPhoto,
    Page,
    Product
} from './../_models/Interfaces';

export const baseUrl = environment.devApiEndpoint;

const no_cache_h = {
    headers: new HttpHeaders({
        'Content-type': 'application/json', 'Pragma': 'no-cache', 'Cache-control': 'no-cache', 'charset': 'utf-8'
    })
};

@Injectable()
export class AuthService {
    constructor(private http: HttpClient) { }
    me(): Observable<Object> {
        return this.http.get(`${baseUrl}/auth/me`);
    }
    signup(body: FormData): Observable<Object> {
        return this.http.post(`${baseUrl}/auth/signup`, body);
    }
    login(body: FormData): Observable<Object> {
        return this.http.post(`${baseUrl}/auth/login`, body);
    }
    recovery(body: FormData): Observable<Object> {
        return this.http.post(`${baseUrl}/auth/recovery`, body);
    }
    reset(body: FormData): Observable<Object> {
        return this.http.post(`${baseUrl}/auth/reset`, body);
    }
    logout(): Observable<Object> {
        return this.http.post(`${baseUrl}/auth/reset`, {});
    }
    refresh(): Observable<Object> {
        return this.http.post(`${baseUrl}/auth/refresh`, {});
    }
}
@Injectable()
export class MiddlewareService {
    constructor(private http: HttpClient) { }
    protected(): Observable<Object> {
        return this.http.get(`${baseUrl}/protected`);
    }
    refresh(): Observable<Object> {
        return this.http.get(`${baseUrl}/refresh`);
    }
}
@Injectable()
export class InvestorService {
    constructor(private http: HttpClient) { }
    getAll(params?: string): Observable<Object> {
        let url = `${baseUrl}/investor`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url, no_cache_h);

    }
    post(body: Object): Observable<Object> {
        return this.http.post(`${baseUrl}/investor`, body, no_cache_h);
    }
    put(id: number, body: Object): Observable<Object> {
        return this.http.put(`${baseUrl}/investor/${id}`, body, no_cache_h);
    }
    get(id: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/investor/${id}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url, no_cache_h);
    }
    getBanks(params?: string): Observable<Object> {
        let url = `${baseUrl}/banks`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url, no_cache_h);
    }
}
@Injectable()
export class InvestorCustomActionsService {
    constructor(private http: HttpClient) { }
    search(searchString: string): Observable<Object> {
        let url = `${baseUrl}/search/investor`;
        if (searchString) url = `${url}?${searchString}`;
        return this.http.get(url, no_cache_h);
    }
    getAddress(id: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/investor/${id}/address`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url, no_cache_h);
    }
    postAddress(id: number, body: Object): Observable<Object> {
        return this.http.post(`${baseUrl}/investor/${id}/address`, body, no_cache_h);
    }
    getContacts(id: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/investor/${id}/contact`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url, no_cache_h)
    }
    deleteContact(id: number, contactId: number) {
        let url = `${baseUrl}/investor/${id}/contact/${contactId}`;
        return this.http.delete(url)
    }
    updateContact(id: number, contactId: number, body: any) {
        let url = `${baseUrl}/investor/${id}/contact/${contactId}`;
        return this.http.put(url, body);
    }
    postContact(id: number, body: Object): Observable<Object> {
        return this.http.post(`${baseUrl}/investor/${id}/contact`, body, no_cache_h);
    }
    getContact(id: number, contactId: number) {
        let url = `${baseUrl}/investor/${id}/contact/${contactId}`;
        return this.http.get(url);
    }
    copyFiscalAddress(id: number): Observable<Object> {
        return this.http.post(`${baseUrl}/investor/${id}/address/copy`, no_cache_h);
    }
    getAll(params?: string): Observable<Object> {
        let url = `${baseUrl}/unit/investor`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url, no_cache_h);
    }
    getMonthlyCuts(id: number, params?: string) {
        let url = `${baseUrl}/investor/${id}/monthly+cut`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url, no_cache_h);
    }
    uploadInvoice(investorId: number, monthlyCutId: number, body: FormData) {
        let url = `${baseUrl}/investor/${investorId}/monthly+cut/${monthlyCutId}/invoice`;
        return this.http.post(url, body);
    }
}
@Injectable()
export class InvestorFilesService {
    constructor(private http: HttpClient) { }
    upload(investorId: number, body: FormData): Observable<Object> {
        return this.http.post(`${baseUrl}/file/${investorId}`, body);
    }
    get(investorId: number, fileId: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/investor/${investorId}/files/${fileId}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    delete(investorId: number, fileId: number): Observable<Object> {
        return this.http.delete(`${baseUrl}/investor/${investorId}/files/${fileId}`);
    }
    getAll(investorId: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/investor/${investorId}/files`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
}
@Injectable()
export class UnitsService {
    constructor(private http: HttpClient) { }
    getAll(params?: string): Observable<Object> {
        let url = `${baseUrl}/unit`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    post(body: FormData): Observable<Object> {
        return this.http.post(`${baseUrl}/unit`, body);
    }
    get(id: number, params?): Observable<Object> {
        let url = `${baseUrl}/unit/${id}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    put(id: number, body: FormData): Observable<Object> {
        return this.http.post(`${baseUrl}/unit/${id}`, body);
    }
}
@Injectable()
export class UnitsCustomService {
    constructor(private http: HttpClient) { }
    search(searchString: string): Observable<Object> {
        let url = `${baseUrl}/search/unit`;
        if (searchString) url = `${url}?${searchString}`;
        return this.http.get(url, no_cache_h);
    }
    getContract(unitId: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/unit/${unitId}/contract`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    postContract(unitId: number, contract: FormData): Observable<Object> {
        return this.http.post(`${baseUrl}/unit/${unitId}/contract`, contract);
    }
    getInsurance(unitId: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/unit/${unitId}/insurance`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    postInsurance(unitId: number, insurance: FormData): Observable<Object> {
        return this.http.post(`${baseUrl}/unit/${unitId}/insurance`, insurance);
    }
    getSummary(params?: string) {
        let url = `${baseUrl}/summary/unit`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    getMonthlyCuts(unitId: number, params?: string) {
        let url = `${baseUrl}/unit/${unitId}/monthly+cut`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
}
@Injectable()
export class UnitFilesService {
    constructor(private http: HttpClient) { }

    upload(unitId: number, body: FormData): Observable<Object> {
        return this.http.post(`${baseUrl}/unit/${unitId}/file`, body);
    }
    get(unitId: number, fileId: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/unit/${unitId}/files/${fileId}`;
        if (url) url = `${url}?${params}`;
        return this.http.get(url, { responseType: "blob" });
    }
    delete(unitId: number, fileId: number): Observable<Object> {
        return this.http.delete(`${baseUrl}/unit/${unitId}/files/${fileId}`);
    }
    getAll(unitId: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/unit/${unitId}/files`;
        if (url) url = `${url}?${params}`;
        return this.http.get(url);
    }
}
@Injectable()
export class ContractsService {
    constructor(private http: HttpClient) { }
    get(id: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/contract/${id}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url, no_cache_h);
    }
    getAll(params?: string): Observable<Object> {
        let url = `${baseUrl}/contract`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url, no_cache_h);
    }
    post(product: Product, body: Object): Observable<Object> {
        return this.http.post(`${baseUrl}/${product.endpoint}/${product.id}/contract`, body);
    }
}
@Injectable()
export class ContractsCustomService {
    constructor(private http: HttpClient) { }
    search(searchString: string): Observable<Object> {
        let url = `${baseUrl}/search/contract`;
        if (searchString) url = `${url}?${searchString}`;
        return this.http.get(url, no_cache_h);
    }
    getFromProduct(product: Product, params?: string) {
        let url = `${baseUrl}/${product.endpoint}/${product.id}/contract`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url, no_cache_h);
    }
}
@Injectable()
export class InsurancesService {
    constructor(private http: HttpClient) { }
    get(id: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/insurance/${id}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url, no_cache_h);
    }
    getAll(params?: string): Observable<Object> {
        let url = `${baseUrl}/insurance`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url, no_cache_h);
    }
    post(product: Product, body: Object): Observable<Object> {
        return this.http.post(`${baseUrl}/${product.endpoint}/${product.id}/insurance`, body);
    }
}
@Injectable()
export class InsurancesCustomService {
    constructor(private http: HttpClient) { }
    search(searchString: string): Observable<Object> {
        let url = `${baseUrl}/search/insurance`;
        if (searchString) url = `${url}?${searchString}`;
        return this.http.get(url, no_cache_h);
    }
    getFromProduct(product: Product, params?: string) {
        let url = `${baseUrl}/${product.endpoint}/${product.id}/insurance`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url, no_cache_h);
    }
}

@Injectable()
export class IncomeService {
    constructor(private http: HttpClient) { }
    getAll(params?: string): Observable<Object> {
        let url = `${baseUrl}/income`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    post(body: Object): Observable<Object> {
        return this.http.post(`${baseUrl}/income`, body, no_cache_h);
    }
    get(id: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/income/${id}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    put(id: number, body: Object): Observable<Object> {
        return this.http.put(`${baseUrl}/income/${id}`, body, no_cache_h);
    }
    delete(id: number) {
        let url = `${baseUrl}/income/${id}`;
        return this.http.delete(url);
    }
}
@Injectable()
export class IncomeCustomService {
    constructor(private http: HttpClient) { }
    search(searchString: string): Observable<Object> {
        let url = `${baseUrl}/search/income`;
        if (searchString) url = `${url}?${searchString}`;
        return this.http.get(url, no_cache_h);
    }
}
@Injectable()
export class ExpenseService {
    constructor(private http: HttpClient) { }
    getAll(params?: string): Observable<Object> {
        let url = `${baseUrl}/expense`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    post(body: Object): Observable<Object> {
        return this.http.post(`${baseUrl}/expense`, body, no_cache_h);
    }
    get(id: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/expense/${id}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    put(id: number, body: Object): Observable<Object> {
        return this.http.put(`${baseUrl}/expense/${id}`, body, no_cache_h);
    }
    delete(id: number) {
        let url = `${baseUrl}/expense/${id}`;
        return this.http.delete(url);
    }
}
@Injectable()
export class ExpenseCustomService {
    constructor(private http: HttpClient) { }
    search(searchString: string): Observable<Object> {
        let url = `${baseUrl}/search/expense`;
        if (searchString) url = `${url}?${searchString}`;
        return this.http.get(url, no_cache_h);
    }
}
@Injectable()
export class PropertyService {
    constructor(private http: HttpClient) { }
    getAll(params?: string): Observable<Object> {
        let url = `${baseUrl}/property`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    get(id: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/property/${id}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
}
@Injectable()
export class PropertyCustomService {
    constructor(private http: HttpClient) { }
    search(searchString: string): Observable<Object> {
        let url = `${baseUrl}/search/property`;
        if (searchString) url = `${url}?${searchString}`;
        return this.http.get(url, no_cache_h);
    }
}
@Injectable()
export class CategoryService {
    constructor(private http: HttpClient) { }
    getAll(params?: string): Observable<Object> {
        let url = `${baseUrl}/category`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    get(id: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/category/${id}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
}
@Injectable()
export class CategoryCustomService {
    constructor(private http: HttpClient) { }
    search(searchString: string): Observable<Object> {
        let url = `${baseUrl}/search/category`;
        if (searchString) url = `${url}?${searchString}`;
        return this.http.get(url, no_cache_h);
    }
}

@Injectable()
export class MonthlyCutService {
    constructor(private http: HttpClient) { }
    getAll(params?: string): Observable<Object> {
        let url = `${baseUrl}/monthly+cut`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    get(id: number, params?: string): Observable<Object> {
        let url = `${baseUrl}/monthly+cut/${id}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    post(body: Object) {
        let url = `${baseUrl}/monthly+cut`;
        return this.http.post(url, body);
    }
    put(id: number) {
        let url = `${baseUrl}/monthly+cut/${id}`;
        return this.http.put(url, {});
    }
}
@Injectable()

export class UserService {
    constructor(private http: HttpClient) { }
    getAll(): Observable<any> {
        return this.http.get(`${baseUrl}/users`) as Observable<any>;
    }
    post(body: Object): Observable<any> {
        return this.http.post(`${baseUrl}/users`, body) as Observable<any>;
    }
    get(id: number): Observable<any> {
        return this.http.get(`${baseUrl}/users/${id}`) as Observable<any>;
    }
    put(id: number, body: Object): Observable<any> {
        return this.http.put(`${baseUrl}/users/${id}`, body) as Observable<any>;
    }
    search(searchString: string): Observable<any[]> {
        let url = `${baseUrl}/search/users`;
        if (searchString) url = `${url}?${searchString}`;
        return this.http.get(url,
            no_cache_h) as Observable<any>;
    }
    getAllRoles(): Observable<any> {
        return this.http.get(`${baseUrl}/roles/users`) as Observable<any>;
    }
    delete(id: number): Observable<Object> {
        return this.http.delete(`${baseUrl}/users/${id}`);
    }
}

@Injectable()
export class MonthlyCutCustomService {
    constructor(private http: HttpClient) { }
    search(searchString: string): Observable<Object> {
        let url = `${baseUrl}/search/monthly+cut`;
        if (searchString) url = `${url}?${searchString}`;
        return this.http.get(url, no_cache_h);
    }
    getMonthlyCutDay(params?: string) {
        let url = `${baseUrl}/monthly+date/cut+day`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    getMonthlyInvoiceDay(params?: string) {
        let url = `${baseUrl}/monthly+date/invoice+day`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    getMonthlyStatementDay(params?: string) {
        let url = `${baseUrl}/monthly+date/statement+day`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    getMonthlyDispersionDay(params?: string) {
        let url = `${baseUrl}/monthly+date/dispersion+day`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    getMonthlyCutForInvestors(id: number, params?: string) {
        let url = `${baseUrl}/monthly+cut/${id}/investors`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    getMonthlyCutsForUnits(id: number, params?: string) {
        let url = `${baseUrl}/monthly+cut/${id}/units`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    sendStatement(id: number, body: FormData) {
        let url = `${baseUrl}/monthly+cut/${id}/sendStatements`;
        return this.http.post(url, body) as Observable<any>;
    }
    generateStatement(id: number, body: FormData) {
        let url = `${baseUrl}/monthly+cut/${id}/generateStatements`;
        return this.http.post(url, body) as Observable<any>;
    }
    askForAuth(userId: number, monthlyCutId: number, params?: string) {
        let url = `${baseUrl}/users/${userId}/monthly+cut/${monthlyCutId}/ask-auth`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    authorize(userId: number, monthlyCutId: number, params?: string) {
        let url = `${baseUrl}/users/${userId}/monthly+cut/${monthlyCutId}/authorize`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    reject(userId: number, monthlyCutId: number, params?: string) {
        let url = `${baseUrl}/users/${userId}/monthly+cut/${monthlyCutId}/reject`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    getIncomesResults(id: number, params?: string) {
        let url = `${baseUrl}/monthly+cut/${id}/income`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    getExpensesResults(id: number, params?: string) {
        let url = `${baseUrl}/monthly+cut/${id}/expense`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    downloadDispersion(monthlycut_id: number, dispersion_type: string) {
        let url = `${baseUrl}/dispersion/${monthlycut_id}/${dispersion_type}/monthly+cut/`;
        return this.http.get(url) as Observable<any>;
    }
}

@Injectable()
export class PaginationService {
    constructor(private http: HttpClient) { }
    next(page: Page, params?: string) {
        if (page.links.next)
            return this.makeRequest(page.links.next, params);
    }
    prev(page: Page, params?: string) {
        if (page.links.previous)
            return this.makeRequest(page.links.previous, params);
    }
    private makeRequest(url: string, params?: string) {
        if (params) url = `${url}&${params}`;
        return this.http.get(url);
    }
}

@Injectable()
export class SummaryService {
    constructor(private http: HttpClient) { }
    getSummary(params?: string): Observable<Object> {
        let url = `${baseUrl}/summary`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
}

@Injectable()
export class LesseeService {
    constructor(private http: HttpClient) { }
    getAll(params?: string): Observable<any> {
        let url = `${baseUrl}/lessee`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url);
    }
    get(id: number, params?: string): Observable<any> {
        let url = `${baseUrl}/lessee/${id}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url) as Observable<any>;
    }
    put(id: number, body: Object): Observable<any> {
        return this.http.put(`${baseUrl}/lessee/${id}`, body) as Observable<any>;
    }
    post(body: Object): Observable<any> {
        return this.http.post(`${baseUrl}/lessee`, body) as Observable<any>;
    }
    delete(id: number) {
        return this.http.delete(`${baseUrl}/lessee/${id}`) as Observable<any>;
    }
}

@Injectable()
export class LesseeCustomService {
    constructor(private http: HttpClient) { }
    search(searchString: string): Observable<Object> {
        let url = `${baseUrl}/search/lessee`;
        if (searchString) url = `${url}?${searchString}`;
        return this.http.get(url, no_cache_h);
    }
}

@Injectable()
export class ConfigService {
    constructor(private http: HttpClient) { }
    getAll(params?: string): Observable<any> {
        let url = `${baseUrl}/configs`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url) as Observable<any>;
    }
    getAllCategories(params?: string): Observable<any> {
        let url = `${baseUrl}/categories/configs`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url) as Observable<any>;
    }
    getAllInvestorDocuments(params?: string): Observable<any> {
        let url = `${baseUrl}/investorDocuments/configs`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url) as Observable<any>;
    }
    get(id: number, params?: string): Observable<any> {
        let url = `${baseUrl}/configs/${id}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url) as Observable<any>;
    }
    getCategory(id: number, params?: string): Observable<any> {
        let url = `${baseUrl}/categories/configs/${id}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url) as Observable<any>;
    }
    getAllTypesUnit(params?: string): Observable<any> {
        let url = `${baseUrl}/typesUnit/configs`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url) as Observable<any>;
    }
    getTypeUnit(id: number, params?: string): Observable<any> {
        let url = `${baseUrl}/typeUnit/configs/${id}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url) as Observable<any>;
    }
    getInvestorDocument(id: number, params?: string): Observable<any> {
        let url = `${baseUrl}/investorDocuments/configs/${id}`;
        if (params) url = `${url}?${params}`;
        return this.http.get(url) as Observable<any>;
    }
    postCategory(body: Object, params?: string): Observable<any> {
        return this.http.post(`${baseUrl}/storeCategories/configs/`, body) as Observable<any>;
    }
    postTypeUnit(body: Object, params?: string): Observable<any> {
        return this.http.post(`${baseUrl}/storeTypeUnit/configs/`, body) as Observable<any>;
    }
    postInvestorDocument(body: Object, params?: string): Observable<any> {
        return this.http.post(`${baseUrl}/storeInvestorDocument/configs/`, body) as Observable<any>;
    }
    putDeadline(id: number, body: Object, params?: string): Observable<any> {
        return this.http.put(`${baseUrl}/updateDeadline/configs/${id}`, body) as Observable<any>;
    }
    putCategory(id: number, body: Object, params?: string): Observable<any> {
        return this.http.put(`${baseUrl}/updateCategories/configs/${id}`, body) as Observable<any>;
    }
    putTypeUnit(id: number, body: Object, params?: string): Observable<any> {
        return this.http.put(`${baseUrl}/updateTypeUnit/configs/${id}`, body) as Observable<any>;
    }
    putInvestorDocument(id: number, body: Object, params?: string): Observable<any> {
        return this.http.put(`${baseUrl}/updateInvestorDocument/configs/${id}`, body) as Observable<any>;
    }
    deleteCategory(id: number, params?: string): Observable<Object> {
        return this.http.delete(`${baseUrl}/category/${id}`);
    }
    deleteTypeUnit(id: number, params?: string): Observable<Object> {
        return this.http.delete(`${baseUrl}/typeUnit/${id}`);
    }
    deleteInvestorDocument(id: number, params?: string): Observable<Object> {
        return this.http.delete(`${baseUrl}/investorDocument/${id}`);
    }
}
@Injectable()
export class DashboardService {
    constructor(private http: HttpClient) { }
    getAll(searchString?: string): Observable<any> {
        let url = `${baseUrl}/dashboard`;
        if (searchString) url = `${url}?${searchString}`;
        return this.http.get(url) as Observable<any>;
    }
    getBarChart(searchString?: string): Observable<any> {
        let url = `${baseUrl}/barChart/dashboard`;
        if (searchString) url = `${url}?${searchString}`;
        return this.http.get(url) as Observable<any>;
    }
    getContract(): Observable<any> {
        let url = `${baseUrl}/contract/dashboard`;
        return this.http.get(url) as Observable<any>;

    }
    getInvestorsBirthday(): Observable<any> {
        let url = `${baseUrl}/investorBirthday/dashboard`;
        return this.http.get(url) as Observable<any>;

    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_services/api.service.ts